import styled from "styled-components";
import { colorV2, media, typographyV2 } from "../../../../constants/styles";
import { Project } from "../../../../constants/projects";
import { Link } from "react-router-dom";
import routes from "../../../../constants/routes";

interface Props {
  project: Project;
  size: "small" | "large";
}
const ProjectCard: React.FC<Props> = ({ project, size }) => {
  return (
    <>
      <Container
        size={size}
        to={`${routes.PROJECT}/${project.key}`}
        onClick={(e) => {
          if (!project.isOpen) {
            e.preventDefault();
          }
        }}
      >
        <StyledFigure>
          <RatioImg src={project.cardBanner} />
        </StyledFigure>
        <TextContainer>
          <TitleContainer>
            <Title>{project.title}</Title>
            {!project.isOpen && <Badge>Coming Soon</Badge>}
          </TitleContainer>
          <Subtitle>{project.subTitle}</Subtitle>
        </TextContainer>
      </Container>
    </>
  );
};

export default ProjectCard;

const Container = styled(Link) <{ size: "small" | "large" }>`
  width: 100%;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: 32px;
  color: #fff;
  
  transition: color 0.3s;

  &:active {
    color: #949494;

    img {
      scale: 0.92;
    }
  }

  @media (hover: hover) {
    &:hover {
      color: #949494;
  
      img {
        scale: 0.92;
      }
    }
  }
`;
const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 0px 16px;
`;

const StyledFigure = styled.figure`
  aspect-ratio: 373.33 / 320;
  width: 100%;
  ${media.TABLET} {
    aspect-ratio: 316 / 260;
  }

  ${media.MOBILE} {
    aspect-ratio: 327 / 260;
    object-fit: cover;
  }
`;

const RatioImg = styled.img`
  width: 100%;
  object-fit: cover;
  transition: scale 0.3s;

`;

const Title = styled.p`
  font-size: 32px;
  font-weight: 700;
  line-height: 44px;
  word-break: keep-all;
  flex: 1;
`;

const Subtitle = styled.p`
  font-size: 24px;
  font-weight: 400;
  line-height: 34px;
  word-break: keep-all;
`;

const TitleContainer = styled.div`
  display: flex;
  align-items: start;
  gap: 4px 12px;
`;

const Badge = styled.div`
  ${typographyV2.BODY_6_M}
  padding: 4px 12px;
  background: ${colorV2.GRAY_02};
  color: #B3FF01;
  border-radius: 8px;
  flex-shrink: 0;
  flex-grow: 0;
`;
